/* We'll import all our JS files and make them available on the window
so we can access them from our templates via Alpine */

import "./base/sentry";

import "htmx.org/dist/htmx";

// import fundsSearch from "./components/fundsSearch";
// window.fundsSearch = fundsSearch; // Used to fetch funds on the "search results" page

// import articlesSearch from "./components/articlesSearch";
// window.articlesSearch = articlesSearch; // Used to fetch articles on the "search results" page

import fundSearch, { initFundFetch } from "./components/fundSearch";
window.initFundFetch = initFundFetch; // Used to get each individual fund on the "top fund ideas" page
window.fundSearch = fundSearch;

import videoModal from "./components/videoModal";
window.videoModal = videoModal; // Gets video modals on mutual fund page

import fundDetail from "./components/fundDetail";
window.fundDetail = fundDetail;

// import peopleSearch from "./components/peopleSearch";
// window.peopleSearch = peopleSearch;

// import briefcaseSearch from "./components/briefcaseSearch";
// window.briefcaseSearch = briefcaseSearch;

import tabInit from "./components/tabbedContent";
window.tabInit = tabInit;

import initHeader from "./components/homepageHeader";
window.initHeader = initHeader;

import initBriefcaseSearch from "./components/specialistBriefcaseSearch";
window.initBriefcaseSearch = initBriefcaseSearch;

import initSevp from "./components/sevp";
window.initSevp = initSevp;

import mutualFundListing from "./components/mutualFundListing";
import searchResults from "./components/searchResults";

import "./partials/searchReset";

import "./partials/externalLink";

// add additional javascript here
function stopVideo() {
	console.log("please stop");
}
